import Footer from './Footer';
import './App.css';
import Calculator from './Calculator';
import Header from './Header';
function App() {
  return (
    <div className="App">
      <Header />
      <Calculator />
      <Footer />
    </div>
  );
}

export default App;
